export var FieldName;
(function (FieldName) {
    FieldName["CAMPAIGN_ID"] = "campaignId";
    FieldName["CLIENT_ID"] = "clientId";
    FieldName["DATA"] = "data";
    FieldName["EVENT_ACTION"] = "eventAction";
    FieldName["EVENT_CATEGORY"] = "eventCategory";
    FieldName["EVENT_LABEL"] = "eventLabel";
    FieldName["EVENT_VALUE"] = "eventValue";
    FieldName["INVITER_ID"] = "inviterId";
    FieldName["LANGUAGE"] = "language";
    FieldName["LOCATION"] = "location";
    FieldName["PAGE"] = "page";
    FieldName["PORTAL_TIME"] = "portalTime";
    FieldName["SCREEN_RESOLUTION"] = "screenResolution";
    FieldName["SEQ"] = "seq";
    FieldName["SESSION_ID"] = "sessionId";
    FieldName["TIMESTAMP"] = "timestamp";
    FieldName["TITLE"] = "title";
    FieldName["TOPIC"] = "topic";
    FieldName["TYPE"] = "type";
    FieldName["USER_ID"] = "userId";
    FieldName["USER_UUID"] = "userUuid";
    FieldName["VIEWPORT_SIZE"] = "viewportSize";
})(FieldName || (FieldName = {}));
export var HitType;
(function (HitType) {
    HitType["pageview"] = "pageview";
    HitType["event"] = "event";
})(HitType || (HitType = {}));
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ../tracker/build/src/types.js
// module id = 470
// module chunks = 0